module.exports = __webpack_public_path__ + "static/media/quicksand-medium.0c642332.ttf";